var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, reaction } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React, { useRef } from 'react';
import { useOnMount } from '../../../hooks/lifecycle.hooks';
import joinClassName from '../../../utils/className.utils';
import { debounce } from '../../../utils/debouncer.utils';
import { useProps, useStore } from '../../../utils/mobx.utils';
import tick from '../../../utils/wait.utils';
import BaseSpacer from '../../BaseSpacer/BaseSpacer';
import LoadingIndicatorSection from '../../LoadingIndicatorSection/LoadingIndicatorSection';
import PageResultItem from '../SearchResultItem/PageResultItem';
import PostResultItem from '../SearchResultItem/PostResultItem';
import ServiceResultItem from '../SearchResultItem/ServiceResultItem';
import TagResultItem from '../SearchResultItem/TagResultItem';
import './SearchResultList.scss';
export var SearchResultType;
(function (SearchResultType) {
    SearchResultType["articles"] = "Articles";
    SearchResultType["pages"] = "Pages";
    SearchResultType["services"] = "Services";
    SearchResultType["tags"] = "Tags";
})(SearchResultType || (SearchResultType = {}));
var SearchResultList = function (props) {
    var scrollRef = useRef(null);
    var p = useProps(props);
    var defaultShowUpTo = 10;
    var s = useStore(function () { return ({
        get numResultsFound() {
            return "" + p.resultsArray.length + (p.resultsArray.length === 10 || p.resultsArray.length === 50 ? "+" : "") + " " + (p.resultsArray.length === 1 ? "result" : "results") + " found.";
        },
        resultItem: function (result) {
            switch (p.resultType) {
                case SearchResultType.articles:
                    return React.createElement(PostResultItem, { key: result.id, post: result });
                case SearchResultType.tags:
                    return React.createElement(TagResultItem, { key: result.id, result: result });
                case SearchResultType.services:
                    return React.createElement(ServiceResultItem, { key: result.id, result: result });
                case SearchResultType.pages:
                    return React.createElement(PageResultItem, { key: result.id, result: result });
                default:
                    return React.createElement(React.Fragment, null);
            }
        },
        showUpTo: defaultShowUpTo,
        reset: debounce(action(function () {
            s.showUpTo = defaultShowUpTo;
        })),
        get hasReachedEndOfList() {
            return !(s.showUpTo < p.resultsArray.length);
        },
        handleScroll: debounce(action(function () {
            if (!scrollRef.current)
                return;
            var rect = scrollRef.current.getBoundingClientRect();
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            if (rect.top - viewHeight <= 0) {
                if (p.resultsArray.length > s.showUpTo) {
                    s.showUpTo += 10;
                }
            }
        }), 300),
        get isServicesList() {
            return p.resultType === SearchResultType.services;
        },
        get isArticlesList() {
            return p.resultType === SearchResultType.articles;
        },
    }); });
    useOnMount(function () { return __awaiter(void 0, void 0, void 0, function () {
        var disposer_1, overlayScrollerRef_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(p.resultType === SearchResultType.articles)) return [3 /*break*/, 2];
                    disposer_1 = reaction(function () { return JSON.stringify(p.resultsArray); }, function () { return s.reset(); });
                    return [4 /*yield*/, tick(500)];
                case 1:
                    _a.sent(); // wait for overlay scroller UI to load.
                    overlayScrollerRef_1 = document.querySelector(".OverlayScroller");
                    overlayScrollerRef_1 === null || overlayScrollerRef_1 === void 0 ? void 0 : overlayScrollerRef_1.addEventListener('scroll', function () { return s.handleScroll(); });
                    return [2 /*return*/, function () {
                            disposer_1();
                            overlayScrollerRef_1 === null || overlayScrollerRef_1 === void 0 ? void 0 : overlayScrollerRef_1.removeEventListener('scroll', s.handleScroll);
                        }];
                case 2: return [2 /*return*/];
            }
        });
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName("searchResultList", p.resultType) },
            React.createElement("h3", null, s.isServicesList ? "Get Support" : p.resultType),
            React.createElement("p", null, s.numResultsFound),
            p.resultsArray.length !== 0 ?
                React.createElement(React.Fragment, null,
                    React.createElement("ul", null, p.resultsArray.slice(0, s.showUpTo).map(function (result) {
                        return s.resultItem(result);
                    })),
                    s.isArticlesList && !s.hasReachedEndOfList && React.createElement("div", { className: "ResultsLoader", ref: scrollRef },
                        React.createElement(BaseSpacer, null),
                        React.createElement(LoadingIndicatorSection, null)),
                    s.isArticlesList && s.hasReachedEndOfList && React.createElement(React.Fragment, null,
                        React.createElement(BaseSpacer, null),
                        React.createElement(LoadingIndicatorSection, { hasReachedEnd: s.hasReachedEndOfList, reachedEndText: "End of List" })))
                :
                    React.createElement(React.Fragment, null)
        // <p>No {p.resultType} found!</p>
        )); } });
};
export default SearchResultList;
